import React, { useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
} from "@mui/material";
import { Colors } from "../../../configs";
import { pxToRem } from "../../../util";

interface ConveyorInputConfigTableProps {
  setRowCount: (count: number) => void;
  selectAll: boolean;
  selectedRows: boolean[];
  setSelectedRows: React.Dispatch<React.SetStateAction<boolean[]>>;
  refreshKey: number;
}

const ConveyorInputConfigTable: React.FC<ConveyorInputConfigTableProps> = ({
  setRowCount,
  selectAll,
  setSelectedRows,
  selectedRows,
  refreshKey,
}) => {
  const [rows, setRows] = React.useState<any[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem("conveyorConfigData");
    const parsed = stored ? JSON.parse(stored) : [];
    const numbered = parsed.map((entry: any, index: number) => ({
      ...entry,
      no: index + 1,
    }));

    setRows(numbered);
    setRowCount(numbered.length);
    setSelectedRows(new Array(numbered.length).fill(selectAll));
  }, [refreshKey, selectAll, setRowCount, setSelectedRows]);

  useEffect(() => {
    setRowCount(rows.length);
  }, [rows.length, setRowCount]);

  return (
    <TableContainer
      component={Box}
      sx={{
        width: pxToRem(1630),
        maxHeight: pxToRem(225),
        overflowY: "auto",
        overflowX: "hidden",
        backgroundColor: Colors.WHITE,
        borderRadius: pxToRem(10),
        "&::-webkit-scrollbar": { width: "0.5rem" },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#ADADAD",
          borderRadius: "0rem",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
          borderRadius: "0rem",
        },
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow
            sx={{ backgroundColor: Colors.BACKSHADE_GRAY, height: pxToRem(45) }}
          >
            <TableCell
              sx={{
                width: "9%",
                textAlign: "center",
                height: pxToRem(45),
                minHeight: pxToRem(45),
                maxHeight: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            />
            <TableCell
              sx={{
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              No:
            </TableCell>
            <TableCell
              sx={{
                width: pxToRem(250),
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              Date
            </TableCell>
            <TableCell
              sx={{
                width: pxToRem(210),
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              Time
            </TableCell>
            <TableCell
              sx={{
                width: pxToRem(210),
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              Cashier ID
            </TableCell>
            <TableCell
              sx={{
                width: pxToRem(210),
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              Bill ID
            </TableCell>
            <TableCell
              sx={{
                width: pxToRem(210),
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              Rack
            </TableCell>
            <TableCell
              sx={{
                width: pxToRem(210),
                fontSize: pxToRem(16),
                color: Colors.MAIN_GRAY,
                fontWeight: "bold",
                height: pxToRem(45),
                padding: "0px",
                lineHeight: pxToRem(45),
              }}
            >
              Location
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index} sx={{ height: pxToRem(45) }}>
              <TableCell
                sx={{
                  textAlign: "center",
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                <Checkbox
                  test-name={`select-row-${index}`}
                  checked={selectedRows[index] || false}
                  onChange={(e) => {
                    const newSelected = [...selectedRows];
                    newSelected[index] = e.target.checked;
                    setSelectedRows(newSelected);
                  }}
                />
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.no}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.date}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.time}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.cashierId}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.billId}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.rack}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: pxToRem(16),
                  color: Colors.MAIN_GRAY,
                  height: pxToRem(45),
                  padding: "0px",
                  lineHeight: pxToRem(45),
                }}
              >
                {row.location}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ConveyorInputConfigTable;
